import exampleSaga from './exampleSaga';
import olSaga from './olSaga';

export default function runSagas(sagaMiddleware) {
  sagaMiddleware.run(exampleSaga);
  sagaMiddleware.run(olSaga);
}
